import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ModalStyle } from '@luggagehero/core';
import {
  CheckInActionBaseComponent,
  CheckOutActionBaseComponent,
  StorageLocationBookingBaseComponent,
} from '@luggagehero/features/shop-manager';
import { ViewImageBaseComponent } from '@luggagehero/features/ui';
import { AppConfig } from '@luggagehero/shared/app-settings/data-access';

import { ViewImageComponent } from '../../../../ui/components/view-image/view-image.component';
import { CheckInActionComponent } from '../booking-actions/check-in-action/check-in-action.component';
import { CheckOutActionComponent } from '../booking-actions/check-out-action/check-out-action.component';

@Component({
  selector: 'lh-storage-location-booking',
  templateUrl: './storage-location-booking.component.html',
  styleUrls: ['./storage-location-booking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StorageLocationBookingComponent extends StorageLocationBookingBaseComponent {
  protected get viewImageComponentType(): Type<ViewImageBaseComponent> {
    return ViewImageComponent;
  }

  protected get checkInActionComponentType(): Type<CheckInActionBaseComponent> {
    return CheckInActionComponent;
  }

  protected get checkOutActionComponentType(): Type<CheckOutActionBaseComponent> {
    return CheckOutActionComponent;
  }

  public profileBackgroundColors = AppConfig.PROFILE_BACKGROUND_COLORS;

  public showLuggageImage(image: string): void {
    void this.modalService.show({
      component: ViewImageComponent,
      componentState: {
        image,
        imageSize: 'large',
      },
      style: ModalStyle.Alert,
      autoWidth: 'md',
    });
  }
}
